module.exports = __webpack_public_path__ + "img/polloplancha.eccf19a2.jpg";